import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  IconButton,
  Icon,
} from 'components';
import styles from './NotificationsTrigger.scss';

const NotificationsTrigger = ({ open, isOpen, hasNewAlerts }) =>
  <IconButton
    onClick={open}
    className={styles.triggerButton}
    disableRipple
    data-testid='alerts_trigger-button'
  >
    <Icon
      name='ion-md-notifications'
      alt='notifications'
      className={classnames(
        styles.notificationIcon,
        {[styles.isOpen]: isOpen, [styles.hasNewAlerts]: hasNewAlerts}
      )}
    />
  </IconButton>;

NotificationsTrigger.propTypes = {
  open: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  hasNewAlerts: PropTypes.bool
};

NotificationsTrigger.defaultProps = {
  hasNewAlerts: false
};

export default NotificationsTrigger;
